module.exports = __webpack_public_path__ + "img/offline.5504b811.svg";